import Vue from 'vue';
import Vuex from 'vuex';
import '../common';
import stores from '../../stores/index';

const store = new Vuex.Store({
  modules: stores,
});

new Vue({
  components: {},
  store: store,
}).$mount('#app');

